module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f073df_banner_800x600.6f125fae.png";